var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderItem"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"bizName"},[_vm._v("\n        "+_vm._s(((_vm.info.shipName || "--") + "(" + (_vm.info.shipType == 2 ? "江船" : _vm.info.shipType == 3 ? "小船" : "") + ")"))+"\n      ")])]),_c('div',{staticClass:"info"},[_c('div',{staticClass:"li"},[_vm._v("\n        VIP状态："+_vm._s(_vm.info.vipStatus == 0
            ? "未收费"
            : _vm.info.vipStatus == 1
            ? "待收款"
            : _vm.info.vipStatus == 2
            ? "已收款"
            : _vm.info.vipStatus == 3
            ? "已到期"
            : "--")+"\n      ")]),_c('div',{staticClass:"li1"},[_vm._v("VIP到期时间："+_vm._s(_vm.info.vipDate || "--"))]),_c('div',{staticClass:"li"},[_vm._v("\n        VIP级别："+_vm._s(_vm.info.vipLevel == 1 ? "3580" : _vm.info.vipLevel == 2 ? "1588" : "--")+"\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }